import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type StatCardGridLayout =
  | "1-2-4"
  | "1-2-3"
  | "1-2-3-4"
  | "2-3-6";

const layoutClass: Record<StatCardGridLayout, string> = {
  "1-2-4": "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6",
  "1-2-3": "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6",
  "1-2-3-4":
    "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6 xl:grid-cols-4",
  "2-3-6": "grid-cols-2 sm:grid-cols-3 lg:grid-cols-6",
};

export interface StatCardGridProps {
  layout: StatCardGridLayout;
  className?: string;
  children: ReactNode;
}

export function StatCardGrid({
  layout,
  className,
  children,
}: StatCardGridProps) {
  return (
    <div className={cn("grid gap-4", layoutClass[layout], className)}>
      {children}
    </div>
  );
}
